// extracted by mini-css-extract-plugin
export default {"selectionOption":"Detections_selectionOption__e5Z7J","selectionOption__selectAllBtn":"Detections_selectionOption__selectAllBtn__YG1+Q"};